<template>
  <div 
  class="details"
  :class="`details--${title}`"
  >
    <p class="details__title"><strong>{{ titleFix }}:</strong></p>
    <p 
      class="details__text" 
      :class="title === '6_extra' ? 'details__extra' : false"
      v-html="info">{{ info }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Details',

  props: ['info', 'title'],

  data() {
    return {
      lang: this.$store.state.lang,
      label: {
        it: {
          '0_when': 'Quando',
          '1_time': 'Ore',
          '2_price': 'Prezzo',
          '3_dresscode': 'Dresscode',
          '4_language': 'Lingua',
          '5_note': 'Note',
          '6_extra': 'Note',
        },
        en: {
          '0_when': 'When',
          '1_time': 'Time',
          '2_price': 'Price',
          '3_dresscode': 'Dresscode',
          '4_language': 'Languages',
          '5_note': 'Notes',
          '6_extra': 'Notes',
        },
      },
    };
  },

  computed: {
    titleFix() {
      return this.label[this.lang][this.title];
    },
  },
};
</script>

<style lang="scss">
@import '../../application';

.details {
  margin: 0 0 5px 0;

  p {
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.6;

    @include mq($from: lg, $and: $is-820) {
      font-size: 1rem;
    }
  }

  &__title {
    display: inline;
    // min-width: 110px;

    text-transform: uppercase;

    strong {
      position: relative;
      display: inline-block;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 35%;
        width: 100%;
        height: 55%;
        opacity: 0.75;

        background: $color-primary;

        z-index: -1;
      }
    }

  }

  &__text {
    display: inline;
    flex: 1 1 0;
  }

  &__mobile {
    display: block;
    margin-top: 10px;
    @include mq(sm) {
      display: none;
    }
  }
}

.details--5_note + .details--6_extra {
  .details__title {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/typo/Details.vue